import React, { useState } from 'react';
import './TeamMeeting.scss';
import StartMeeting from './StartMeeting/StartMeeting';
// import PersonalFeedback from './PersonalFeedback/PersonalFeedback';
import TeamPresentation from './TeamPresentation/TeamPresentation';
import MeetingConclusion from './MeetingConclusion/MeetingConclusion';
import Modal from './Modal/Modal';
// import Navbar from './Navbar/Navbar';
import Transcript from './Transcript/Transcript';
import Button from '../../partials/Button'
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

const TeamMeeting = (props) => {

    const [people, setPeople] = useState({...props.data.people})

    const speakers = Object.keys(props.data.scripts)
    console.log('speakers: ', speakers);

    // we will need a useState to hold the data for the current team member the user is playing as. The entire script of the meeting might depend on which team member the user is "playing as".
    const [currentTeamMember, setCurrentTeamMember] = useState(props.data.initialTeam);

    const [currentFrame, setCurrentFrame] = useState('startMeeting');

    const [frameStack, setFrameStack] = useState([]);

    const [showBackModal, setShowBackModal] = useState(false);

    const [optionsTranscript, setOptionsTranscript] = useState([]);

    const [transcriptVisibility, setTranscriptVisibility] = useState(false);

    // Convo points removed for now
    // const [convoPoints, setConvoPoints] = useState(0);

    const pushFrame = frame => {
        frameStack.push(currentFrame);
        setCurrentFrame(frame);
        setFrameStack(frameStack);
    }

    const popFrame = () => {
        const frame = frameStack.pop();
        setCurrentFrame(frame);
        setFrameStack(frameStack);
    }

    const onConclusionClicked = () => {
        if (props.data.scripts[currentTeamMember].nextScript) {
            setCurrentFrame('startMeeting')
            // setOptionsTranscript([])
            setCurrentTeamMember(props.data.scripts[currentTeamMember].nextScript)
        } else {
            props.onComplete()
        }
    };

    // const makePersonalFeedback = (feedback, nextFrame) => (
    //     <PersonalFeedback 
    //         teamMember={props.data.people[feedback.person]} 
    //         content={feedback.content} 
    //         speakerView={feedback.speakerView}
    //     >
    //         <div className="feedback-outer-button">
    //           <button className='global-button ' onClick={() => {pushFrame(nextFrame)}}>Next</button>  
    //         </div>
            
    //     </PersonalFeedback>
    // );

    // Eventually we want to make a state to pass into these components instead of the hard coded props that are currently being passed in. This way we can reduce the number we have here and make them more reusable. The idea would be depending on what the state is set to, we will get different JSON data for the subcomponent

    return <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs} >
        <div className='team-meeting'>
    
            {currentFrame !== 'startMeeting' && <div className="back-btn-container">
                <Button variant='back' text="Back" onClick={() => setShowBackModal(true)} />
            </div>}
            
            {/* <Navbar 
                onTranscriptClicked={() => setTranscriptVisibility(!transcriptVisibility)} 
                transcriptEnabled={optionsTranscript.length > 0} 
            /> */}
            
            {transcriptVisibility && 
                <Transcript 
                    // presentationSlides={props.data.scripts[currentTeamMember].presentationSlides} 
                    speakers={speakers}
                    scripts={props.data.scripts}
                    setTranscriptVisibility={setTranscriptVisibility} 
                    teamMember={props.data.people[currentTeamMember]} 
                    transcript={optionsTranscript} 
                    // people={props.data.people} 
                    people={people} 
                />
            }

            <div className='team-presentation'>
                <div className='border-container'>
                    <div className={transcriptVisibility ? 'display-none' : 'team-meeting-content'}>
                        {(() => {
                            if (currentFrame === 'startMeeting') {
                                return <StartMeeting {...props}
                                    data={props.data}
                                    people={people} 
                                    teamMemberKey={currentTeamMember}
                                    setPeople={setPeople}
                                    defaultInstructions={props.data.profileInstructions}
                                    // intro={props.data.scripts[currentTeamMember].intro.speaker.content}
                                    intro={props.data.scripts[currentTeamMember].intro}
                                    startMeeting={() => { pushFrame('presentation') }}
                                />
                            }

                            if (currentFrame === 'presentation') {
                                return <TeamPresentation
                                    data={props.data}
                                    setOptionsTranscript={setOptionsTranscript}
                                    optionsTranscript={optionsTranscript}
                                    transcriptVisibility={transcriptVisibility}
                                    setTranscriptVisibility={setTranscriptVisibility}
                                    presentationSlides={props.data.scripts[currentTeamMember].presentationSlides}
                                    teamMember={people[currentTeamMember]}
                                    onConclusion={() => { pushFrame('conclusion') }}
                                    people={people}
                                    // convoPoints={convoPoints}
                                    // setConvoPoints={setConvoPoints}
                                />
                            }

                            if (currentFrame === 'conclusion') {
                                return <MeetingConclusion
                                    teamMember={props.data.people[currentTeamMember]}
                                    onConclusionClicked={onConclusionClicked}
                                    conclusionText={props.data.scripts[currentTeamMember].conclusion} />
                                    // convoPoints={convoPoints}
                                    // setConvoPoints={setConvoPoints}
                            }
                        })()}
                    </div>
                </div>
            </div>

            {showBackModal && <Modal>
                    <div className='main-container back-modal'>
                        <p className='back-txt'>Are you sure you want to go back? <br/> You will lose any unsaved progress.</p>
                    </div>
                    <div className='btn-container'>
                        <img className='button' src='media/img/buttons/confirm-btn.png' onClick={() => {popFrame(); setShowBackModal(false);}} alt='confirm' />
                        <img className='button' src={'media/img/buttons/close-btn.png'} onClick={() => setShowBackModal(false)} alt='close' />
                    </div>
                </Modal>}
        </div>
    </InteractionContainer>  
}




export default TeamMeeting;